import tw from 'twin.macro'
import { useContext } from 'react'
import { MCsContext } from '../mcs/MCs.context'
import { MCsTableContext } from '../mcs-table/MCsTable.context'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'

export const MCsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(MCsContext)
  const { tagsFilter, setTagsFilter } = useContext(MCsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-4`}>
        <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
        <TableTagsSelect selectedTags={tagsFilter} setSelectedTags={setTagsFilter} />
      </div>
    </div>
  )
}
